const TAB_UNREAD_UNAVAILABLE_KEY = "finlo_tab_unread_counts_unavailable";

const missingDocumentDetailIds = new Set();

export function isNotFoundApiResponse(res) {
  return res?.status === 404;
}

export function isTabUnreadCountsApiUnavailable() {
  try {
    return sessionStorage.getItem(TAB_UNREAD_UNAVAILABLE_KEY) === "1";
  } catch {
    return false;
  }
}

export function markTabUnreadCountsApiUnavailable() {
  try {
    sessionStorage.setItem(TAB_UNREAD_UNAVAILABLE_KEY, "1");
  } catch {
    /* ignore */
  }
}

export function isDocumentDetailMissing(documentId) {
  const id = String(documentId ?? "");
  return id !== "" && missingDocumentDetailIds.has(id);
}

export function markDocumentDetailMissing(documentId) {
  const id = String(documentId ?? "");
  if (id) missingDocumentDetailIds.add(id);
}

export function isEndpointNotImplementedError(error) {
  const status = error?.response?.status;
  return status === 404 || status === 405 || status === 501;
}
